import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          用户反馈
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          影迷们对51电影网的真实评价
        </p>
        <div className="space-y-4">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <span className="text-sm font-medium text-foreground-800 block">
                    {comment.name}
                  </span>
                  <span className="text-xs text-foreground-400">{comment.date}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}